import React, { useState, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import Home from "./pages/Home";
import Suites from "./pages/Suites";
import Gallery from "./pages/Gallery";
import Tariff from "./pages/Tariff";
import ContactPage from "./pages/ContactPage";
import Navbar from "./components/Navbar";
import WhatsAppFloatingIcon from "./components/WhatsAppFloatingIcon.jsx";
import Footer from "./components/Footer";
import Decor from "./pages/Decor";
import CallFloatingIcon from "./components/CallFloatingIcon.jsx";
import LoadingScreen from "./pages/Loading";
import "./App.css";
import TheTropicalSuite from "./pages/TheTropicalSuite.jsx";
import TheAmberSuite from "./pages/TheAmberSuite.jsx";
import TheEarthenSuite from "./pages/TheEarthenSuite.jsx";

const AppContent = () => {
  const location = useLocation();
  const nodeRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 4500);
      return () => clearTimeout(timer);
    }
  }, [isLoading]); // Add 'isLoading' as a dependency safely
  
  useEffect(() => {
    const suitePages = ["/the-tropical-suite", "/the-amber-suite", "/the-earthen-suite"];
    
    if (suitePages.includes(location.pathname)) {
      setIsLoading(true);
    }
  }, [location.pathname]); // This effect runs only when the route changes
  
  

  return (
    <>
      <CSSTransition
        in={isLoading}
        timeout={500}
        classNames="slide-fade"
        nodeRef={nodeRef}
        unmountOnExit
      >
        <LoadingScreen />
      </CSSTransition>

      {!isLoading && (
        <>
          {location.pathname !== "/contact" && <Navbar />}
          <WhatsAppFloatingIcon />
          <CallFloatingIcon />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/suites" element={<Suites />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/decor" element={<Decor />} />
            <Route path="/tariff" element={<Tariff />} />
            <Route path="/the-tropical-suite" element={<TheTropicalSuite />} />
            <Route path="/the-amber-suite" element={<TheAmberSuite />} />
            <Route path="/the-earthen-suite" element={<TheEarthenSuite />} />
          </Routes>

          {location.pathname !== "/contact" && <Footer />}
        </>
      )}
    </>
  );
};


const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
